import './index.css';

import classnames from 'classnames';

export const Pill = ({ as = 'div', children, className, ...props }) => {
  if (!children) return null;

  const El = as;

  return (
    <El className={classnames('comp-pill', className)} {...props}>
      <span className="comp-pill__dot" aria-hidden="true" />
      <span className="comp-pill__text">{children}</span>
    </El>
  );
};
